module.exports = __webpack_public_path__ + "static/media/05-mobile-2.b308158b.png";